import * as React from "react";
import Svg, { Path } from "react-native-svg";

function IcSystemBrokenImage(props) {
  return (
    <Svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.62911 5.68187L11.25 5L10.1768 7.13288L11.5599 9.26576L10.6378 11.3986L11.5599 13.105C11.4914 14.0383 10.8343 14.6831 9.80453 14.6934C9.51123 14.6964 9.25375 14.5377 8.98746 14.4154C5.55206 12.8386 2.25 19.4176 11.5599 16.6176L12 18.3L6.2927 18.9896C5.31829 19.0928 4.43819 18.4185 4.31325 17.4729L3.01489 7.64714C2.88526 6.66606 3.61671 5.77554 4.62911 5.68187ZM6.59855 8.33296C6.10368 8.37618 5.73617 8.80162 5.77769 9.28319L5.85287 10.1552C5.89439 10.6367 6.32922 10.9921 6.82408 10.9488L7.72012 10.8706C8.21498 10.8274 8.58249 10.4019 8.54097 9.92034L8.4658 9.04838C8.42428 8.56681 7.98945 8.21146 7.49458 8.25469L6.59855 8.33296Z"
        fill={props.accentColor}
      />
      <Path
        d="M12.5683 7.29016L14.2518 5L18.8548 5.00318C20.0145 5.00398 20.9304 5.98771 20.8485 7.14446L20.1489 17.0235C20.0713 18.1181 19.1264 18.9458 18.0312 18.8785L12.5045 18.5388L12 16.9047L17.2888 16.9887C17.7146 16.9955 18.1031 16.73 18.2277 16.3228C19.7525 11.3408 16.8131 9.64233 12.5683 12.8743L12.0083 11.722L13.6881 9.50607L12.5683 7.29016Z"
        fill={props.accentColor}
      />
    </Svg>
  );
}

IcSystemBrokenImage.defaultProps = {
  accentColor: "#687176",
  fillColor: "#0194F3",
  width: 24,
  height: 24,
};
export default IcSystemBrokenImage;
